<template>
  <v-container style="padding-top: 50px;">
    <h2>Sign up</h2>
    <span>If you already have an account, you should
      <router-link :to="{ name: 'login' }">login</router-link>
    </span>
    <v-row style="padding-top: 20px;">
      <v-btn 
       large 
       rounded
       color="primary"
       @click="signup"
      >Sign Up with Google</v-btn>
    </v-row>
  </v-container>
</template>

<script>
  import firebase from 'firebase'
  
  export default {
    name: 'signup',
    data () {
      return {
        googleAuth: new firebase.auth.GoogleAuthProvider()
      }
    },
    methods: {
      signup () {
        firebase.auth().signInWithPopup(this.googleAuth)
          .then(() => {
            this.$store.dispatch('setSnackbar', {
              snackbarColor: 'success',
              showSnackbar: true,
              snackbarY: 'top',
              snackbarX: 'right',
              snackbarText: `Sign up successful!`
            })
            this.$router.push({ name: 'Welcome' })
          })
          .catch((err) => {
            console.error(err)
          })
      }
    }
  }
</script>
